import React, { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

import { useConfirm } from 'src/hooks';
import { Props as ConfirmProps } from 'src/components/applications/Confirm';

export type Props = {
  when?: boolean;
  confirmProps?: ConfirmProps;
  shouldNavigateAfterOk?: boolean;
  shouldUnblockAfterCancel?: boolean;
};

const BlockNavigate: React.FC<Props> = ({
  when = false,
  confirmProps,
  shouldNavigateAfterOk = true,
  shouldUnblockAfterCancel,
}) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const { Confirm, open } = useConfirm(confirmProps);

  useEffect(() => {
    if (!when) return;

    let nav: any = navigator;

    const unblock = nav.block((tx) => {
      open({
        ...confirmProps,
        onCancel() {
          confirmProps?.onCancel?.();
          shouldUnblockAfterCancel && unblock();
          !shouldNavigateAfterOk && navigator.push(tx.location.pathname);
        },
        async onOk() {
          await confirmProps?.onOk?.();

          unblock();
          shouldNavigateAfterOk && navigator.push(tx.location.pathname);
        },
      });
    });

    return unblock;
  }, [when, navigator]);

  return <Confirm />;
};

export default BlockNavigate;
